import React from 'react';
import { selectedComponent } from '../../../redux/selectedComponentSlice';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';
import { ViewportList } from 'react-viewport-list';
import CssEditorRow from './CssEditorRow';
import { scrollBarStyle } from '../../../utils/layoutConfig';

const CssEditorBody = () => {
	const { props: selectedComponentValue } = useSelector(selectedComponent);
	const [openList, setOpenList] = React.useState([]);
	const viewportRef = React.useRef(null);

	if (!selectedComponentValue?.variables) return null;
	const { variables, componentId } = selectedComponentValue;

	const toggleOpen = (idx) => {
		const newOpenList = [...openList];

		return () => {
			newOpenList[idx] = !openList[idx];
			setOpenList(newOpenList);
		};
	};

	if (!variables.length) return null;
	return (
		<Flex
			sx={{ ...scrollBarStyle, ...{ gap: '8px' } }}
			overflow={'auto'}
			maxH={500}
			width={'100%'}
			borderRadius={'10px'}
			mt={1}
			flexWrap={'wrap'}
			ref={viewportRef}
		>
			<ViewportList viewportRef={viewportRef} items={variables}>
				{({ type, list }, idx) => {
					return (
						<CssEditorRow
							key={`css-row-${type}-${idx}`}
							{...{ list, componentId, type }}
							toggleOpen={toggleOpen(idx)}
							isOpen={openList[idx]}
						/>
					);
				}}
			</ViewportList>
		</Flex>
	);
};

export default CssEditorBody;
